import { Avatar, Box, Container, Grid, Typography } from "@mui/material";
import React, { useState, useRef, useContext, useEffect } from "react";
import bg from "../@shared/assets/mydecksbg.png";
import { useNavigate } from "react-router-dom";
import NeoButton from "../components/NeoButton";
import { useAuthStore } from "../@shared/store/useAuthStore";
import { MainContext } from "../App";
import SettingsDrawer from "../components/SettingsDrawer";
import { Add, ArrowForwardIos, MenuRounded } from "@mui/icons-material";
import Toast from "../components/Toast";
import { doc, updateDoc } from "firebase/firestore";
import { db } from "../@shared/firebase/config";
import { useTutorial } from "../@shared/utils/useTutorial";
import TutorialInfinityOrb from "../components/TutorialInfinityOrb";
import IOIntro from "../components/tutorialSequences/IOIntro";
import PracticeGameBoard from "../components/tutorialSequences/PracticeGameBoard";
import PracticeWorld from "../components/tutorialSequences/PracticeWorld";

const TutorialSequences = () => {
  const { navigate, partyId, setPartyId, setIsHost, isHost } =
    useContext(MainContext);
  const { Theme, setError, setMessage } = React.useContext(MainContext);
  const { userData } = useAuthStore();
  const { progress, sequence, advanceStep } = useTutorial(userData?.id);

  const handleSkip = async () => {
    const docRef = doc(db, "users", userData.id);
    setMessage("Tutorial Skipped!");
    setError(true);
    await updateDoc(docRef, {
      completedTutorial: true,
    });
  };

  return (
    <Grid
      container
      xs={12}
      sx={{
        height: "100dvh",
        background: "black",
        overflow: "hidden",
        position: "relative",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top:
            sequence?.type === "deckBuilder"
              ? { xs: "14%", md: "2%" } // bottom-left on xs, top-right on md+
              : "2%",
          right:
            sequence?.type === "deckBuilder"
              ? { xs: "4%", md: "2%" } // bottom-left on xs, top-right on md+
              : "2%",
          zIndex: 9999,
          width:
            sequence?.type === "deckBuilder"
              ? { xs: "120px", md: "200px" } // bottom-left on xs, top-right on md+
              : "200px",
        }}
      >
        <NeoButton
          text={"Skip Tutorial"}
          onClick={handleSkip}
          color={Theme.palette.secondary.main}
          width={100}
        />
      </Box>
      {progress?.currentSequence === "introDialogue" &&
        sequence?.type === "dialogue" && <IOIntro />}

      {progress?.currentSequence === "guidedBattle" && <PracticeGameBoard />}
      {progress?.currentSequence === "firstDeck" && <PracticeWorld />}
    </Grid>
  );
};

export default TutorialSequences;
